import { PAGES } from '@/constants/pages';
import { DashboardIcon, OrdersIcon, PatientsIcon, TasksIcon } from '@/icons';
import SidebarButton from '../SidebarButton';

export type LabSidebarProps = {
  color?: string;
  bgColor?: string;
  iconClassName?: string;
};

export default function LabSidebar({
  iconClassName,
  ...props
}: LabSidebarProps) {
  return (
    <>
      <SidebarButton
        {...props}
        href={PAGES.LAB_DASHBOARD}
        label="Dashboard"
        icon={<DashboardIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.LAB_TASKS}
        label="Tasks"
        icon={<TasksIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.LAB_ORDERS}
        label="Orders"
        icon={<OrdersIcon className={iconClassName} />}
      />
      <SidebarButton
        {...props}
        href={PAGES.LAB_CUSTOMERS}
        label="Customers"
        icon={<PatientsIcon className={iconClassName} />}
      />
    </>
  );
}
